import { Injectable } from '@angular/core';
import { LoggerService } from '@wephone-utils/services/logger.service';

@Injectable()
export class ScreenLockService {
    private requestActive = false;
    private lockHandle: any;

    constructor(private readonly loggerService: LoggerService) {
        document.addEventListener('visibilitychange', async () => {
            if (this.requestActive && document.visibilityState === 'visible') {
                await this.doRequestLock();
            }
        });
    }

    requestLock(): Promise<any> {
        if (!('wakeLock' in navigator)) {
            return;
        }

        this.requestActive = true;
        return this.doRequestLock();
    }

    async doRequestLock(): Promise<any> {
        if (this.lockHandle) {
            return;
        }
        try {
            this.lockHandle = await (navigator['wakeLock'] as any).request();
            // this.loggerService.log(`Screen Wake Lock obtained`);
            this.lockHandle.addEventListener('release', () => {
                if (this.lockHandle) {
                    // this.loggerService.log('Screen Wake Lock released');
                }
                this.lockHandle = undefined;
            });
            return this.lockHandle;
        } catch (err) {
        }
    }

    releaseLock(): void {
        this.requestActive = false;
        if (!this.lockHandle) {
            return;
        }

        try {
            this.lockHandle.release();
            this.lockHandle = undefined;
        } catch (err) {
            this.loggerService.error(`Unable to release screenlock ${err.name}, ${err.message}`);
        }
    }
}
